var toggleInputByEnter = (function (inputRef) {
    return function (parentEvent) {
        if (['Enter', 'NumpadEnter'].includes(parentEvent.key) &&
            inputRef.current) {
            var event_1 = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            inputRef.current.dispatchEvent(event_1);
        }
    };
});

export { toggleInputByEnter as default };
